// src/api/survey.ts
import apiClient from './client';
import type { SurveyType } from '@/types/surveyTypes';

export async function fetchQuestions(survey_id: number) {
  const { data } = await apiClient.get(`/api/survey/${survey_id}/questions`);
  return data;
}

/**
 * Survey API module for enhanced survey questions
 */
export const surveyAPI = {
  /**
   * Get survey questions by survey type
   * Maps survey type to ID: pulse = 1, shape = 2
   */
  getQuestions: async (surveyType: SurveyType) => {
    const surveyId = surveyType === 'pulse' ? 1 : 2;
    const { data } = await apiClient.get(`/api/survey/${surveyId}/questions`);
    return data;
  }
};

export async function submitResponse(userModuleId: number, questionId: number, response: number | string) {
  const url = `/api/survey/${userModuleId}/survey_responses/${questionId}`;
  // Use different attribute based on response type
  const payload = typeof response === 'string' 
    ? { textResponse: response }
    : { response: response };
  
  console.log('submitResponse API call:', {
    url,
    payload,
    method: 'POST'
  });
  
  try {
    const { data } = await apiClient.post(url, payload);
    console.log('submitResponse API success:', data);
    return data;
  } catch (error) {
    console.error('submitResponse API error:', error);
    throw error;
  }
}

// Add this function to fetch responses for a survey and user module
export async function fetchResponses(survey_id: number, userModuleId: number) {
  const { data } = await apiClient.get(`/api/survey/${survey_id}/responses/${userModuleId}`);
  return data;
}

// New endpoint for AI analysis of survey responses
export async function analyzeSurveyResponse(questionId: number, responseValue: number, userModuleId: number) {
  const { data } = await apiClient.post('/api/surveys/analyze-response', {
    question_id: questionId,
    response_value: responseValue,
    user_module_id: userModuleId
  });
  return data;
}